import board from './board'
import card from './card'
import lane from './lane'

export default [
  board,
  card,
  lane
]